import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Divider } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface Props {
  title: string;
  children?: React.ReactNode;
}

export const Section: React.FC<Props> = (props) => {
  const { title, children } = props;
  const [expanded, setExpanded] = React.useState(true);
  return (
    <Accordion
      className="p-0 bt-0"
      elevation={0}
      expanded={expanded}
      onChange={(e, value) => setExpanded(value)}
    >
      <AccordionSummary className="flex text-gray-700 font-medium p-0 space-x-2">
        <p>{title}</p>
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </AccordionSummary>
      <AccordionDetails className="p-0">
        <Divider />
        <div className="py-3">{children}</div>
      </AccordionDetails>
    </Accordion>
  );
};
Section.displayName = 'Filters.More.Section';
